import { Pipe, PipeTransform } from '@angular/core';
import { Installer, InstallerTypes, User } from '~gc/domains/users/user/user.model';

@Pipe({ name: 'isInstaller' })
export class IsInstallerPipe implements PipeTransform {
  transform(user?: User): user is Installer {
    return user?.type ? InstallerTypes.includes(user.type) : false;
  }
}
